import React, { Component } from 'react';
import firebase from './firebaseConnection';
import '../styles/App.css';

const storageRef = firebase.storage().ref('businessIdeas')

class uploadFile extends Component {
  constructor() {
      super()
      this.state = {
        uploading: false,
        percent: '',
        file: '',
        error: '',
        availableIdeas: ''
      }
      this.handleFileSelect = this.handleFileSelect.bind(this)
      this.handleFileUpload = this.handleFileUpload.bind(this)
      this.handleIdeasBusiness = this.handleIdeasBusiness.bind(this)
    }

    componentDidMount() {
      firebase.database().ref('BusinessIdeas/Availables').once('value').then(snapshot => {
        this.setState({ availableIdeas: snapshot.val() })
      })
    };

    handleFileSelect(e) {
        this.setState({percent: 0});
        this.setState({file: e.target.files[0]})
        this.setState({uploading: false})
    }

    handleFileUpload() {
      this.setState({uploading: true})
      storageRef.child(this.state.file.name)
        .put(this.state.file)
        .then(snapshot => {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.setState({percent: progress});
          this.setState({file: ''})
          this.handleIdeasBusiness(snapshot.metadata);
        })
        .catch(err => this.setState({error: err.message}))
    }

    handleIdeasBusiness(item) {
      var availables = this.state.availableIdeas - 1;
      var setAvailables =  firebase.database.Reference =  firebase.database().ref('BusinessIdeas/Availables');
      setAvailables.set(availables)
      this.setState({ availableIdeas: availables})
      /***********************************************************************/
      var key = item.name.replace('.pdf','');
      var businessIdeasList =  firebase.database.Reference =  firebase.database().ref('BusinessIdeas/Ideas');
      var businessIdea = businessIdeasList.child(key);
      businessIdea.set({
        UrlIdea: item.downloadURLs[0]
      })
    }


    render() {
      var upload;
      if (this.state.availableIdeas !== 0) {
        upload =
        <div>
          <div>
            <label htmlFor="file-upload" className="custom-file-upload"> {this.state.file == '' ?
              <i className="fa fa-cloud-upload">Elegir archivo</i>
              :
              <i className="fa fa-cloud-upload">{this.state.file.name}</i>
            }
            </label>
            <input id="file-upload" type="file"  accept="application/pdf" onChange={this.handleFileSelect}/>
            <button onClick={this.handleFileUpload} className="uploadButton">Enviar archivo</button>
          </div>
          {this.state.uploading
            ? this.state.percent != 0 ? <div>
                <div className='load-bar'/>
                <span>¡Carga completa! Su idea de negocio se ha enviado exitosamente.</span>
              </div> : ''
            : this.state.percent == '' ? "*Sólo se aceptan archivos en formato .pdf" : ''
          }
        </div>
      }
      else {
        upload = <h1 className="uploadAdvice">Lo sentimos, ya no contamos con espacios disponibles para presentar ideas de negocios</h1>
      }
      return (
        <div>
          {upload}
        </div>
      )
    }
  }

export default uploadFile;



// WEBPACK FOOTER //
// ./src/app/uploadFiles.js